import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

export class TranslateSessionLoader implements TranslateLoader {
	private static readonly TRANS = "TRANSLATIONS_";

	constructor(
		private http: HttpClient,
		private storageService: StorageManagerService,
		private prefix: string,
		private suffix: string
	) { }

	getTranslation(lang: string): Observable<Record<string, string>> {
		const key = TranslateSessionLoader.TRANS + lang;

		if (this.storageService.hasSessionItem(key)) {
			return of(this.storageService.getSessionItem(key, {}));
		}

		return this.http.get<Record<string, string>>(`${this.prefix}/${lang}${this.suffix}`).pipe(
			map(v => {
				this.storageService.setSessionItem(key, v);
				return v;
			})
		);
	}
}